import { FullPageSpinner } from '@/components/loading_states/generic-spinner'
import { AbilityProvider } from '@/components/providers/ability-provider'
import { useAuth } from '@/components/providers/auth-provider'
import { SidebarProvider } from '@/components/ui/sidebar'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import {
  browserName,
  browserVersion,
  deviceType,
  isDesktop,
  isMobile,
  isTablet,
  osName,
  osVersion,
} from 'react-device-detect'

export const Route = createFileRoute('/dashboard')({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    if (!context || !context.auth || context.auth?.isPending) {
      // Don't redirect yet, let the pendingComponent show
      return
    }
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: '/login' })
    }
    if (!context.auth.isUserOnboarded) {
      throw redirect({ to: '/onboarding' })
    }
  },
  pendingComponent: () => <FullPageSpinner />,
})

function RouteComponent() {
  // const navigate = useNavigate()
  const { user } = useAuth()
  // const { user, clientId } = useAuth()
  console.log({ user })
  console.log({
    isMobile,
    isTablet,
    isDesktop,
    browserName,
    browserVersion,
    osName,
    osVersion,
    deviceType,
  })

  // if (isPending) return <FullPageSpinner />

  // // fixes weird bugs in prod (i think), i.e. the !isLoading part
  // if (!isAuthenticated && !isPending) navigate({ to: '/login' })

  // if (!isUserOnboarded && !isPending) navigate({ to: '/onboarding' })

  return (
    <AbilityProvider
      // user={{
      //   // userId: user?.userId ?? '',
      //   // businessId: user?.businessId ?? '',
      //   // userRole: user?.role ?? '',
      //   // clientId,
      // }}
      user={user}
      userRoles={user?.userRoles?.map((userRole) => userRole.role.name ?? '') ?? []}
    >
      <SidebarProvider>
        <div className="min-h-screen w-screen bg-accent/5">
          <Outlet />
        </div>
      </SidebarProvider>
    </AbilityProvider>
  )
}
